import { ProtectedMenuComponent } from "./component";

export const ProtectedMenu = ProtectedMenuComponent;
